import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-root',
  templateUrl: './language-root.component.html',
  styleUrls: ['./language-root.component.scss']
})
export class LanguageRootComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
